import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Alert, Button, Loader, Modal, Table } from '@itds/elements';
import { ANNUITY_RIDER_LABELS, RIDER_LABELS } from '@itds/Constants';

import EditTableRateDrawer from './Edit';

import Api from '@carrier/utils/Api';

const List = ({ version }) => {
  const params = useParams();

  const [riders, setRiders] = useState([]);
  const [rider, setRider] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error_message, setErrorMessage] = useState(null);
  const [success_message, setSuccessMessage] = useState(null);
  const [modal, setModal] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);

  useEffect(() => {
    loadRiders();
  }, []);
  const loadRiders = action => {
    setLoading(true);

    setTimeout(() => {
      setSuccessMessage(null);
      setErrorMessage(null);
    }, 2000);

    Api.loadAnnuityRiders({ beacon_product_id: version.beacon_id })
      .then(({ data }) => {
        setLoading(false);
        // Filter for annuity-specific riders or use all riders for now
        setRiders(data);
        if (action === 'add') {
          setSuccessMessage('Riders Successfully Added');
        } else if (action === 'delete') {
          setSuccessMessage('Rider Successfully Deleted');
        }
      })
      .catch(() => {
        if (action === 'add') {
          setErrorMessage('Unable to add Riders at this time');
        } else if (action === 'delete') {
          setErrorMessage('Unable to delete Riders at this time');
        }
      });
  };

  const handleSave = () => {
    setRider(null);
    loadRiders('add');
  };

  const handleDelete = (obj, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);
    setModal(true);
    setDeleteInfo(obj);
  };

  const confirmDelete = () => {
    window.scrollTo(0, 0);

    Api.deleteAnnuityRider(deleteInfo.id)
      .then(() => {
        loadRiders('delete');
        setModal(null);
        setDeleteInfo(null);
      })
      .catch(() => {
        setModal(null);
        setDeleteInfo(null);
      });
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      <EditTableRateDrawer
        onClose={setRider.bind(null, null)}
        onSave={handleSave}
        rider={version}
        riderId={rider?.id || null}
        show={!!rider}
      />{' '}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button
          onClick={setRider.bind(null, {
            carrier_id: params.id,
            data_version_id: params.version_id
          })}
          style={{}}
        >
          Add Rider
        </Button>
      </div>
      <Table
        columns={[
          {
            id: 'name',
            label: 'Rider Name',
            is_sortable: true
          },
          {
            id: 'rider_type',
            is_sortable: true,
            label: 'Rider Type',
            render: rider => {
              // Try annuity rider labels first, fallback to life rider labels
              return (
                ANNUITY_RIDER_LABELS[rider.rider_type] ||
                RIDER_LABELS[rider.rider_type] ||
                rider.rider_type
              );
            }
          },
          {
            id: 'version',
            label: 'Rider Version',
            is_sortable: true,
            render: rider => rider.version || rider.data_version_id || 'v1.0'
          },
          {
            id: 'state_approvals',
            label: 'State Approvals',
            render: rider => {
              if (rider.approved_states && rider.approved_states.length > 0) {
                const stateCount = rider.approved_states.length;
                const stateList = rider.approved_states.slice(0, 3).join(', ');

                return stateCount > 3 ? `${stateList} +${stateCount - 3} more` : stateList;
              }
              return rider.use_quote_column_states ? 'All Quote States' : 'No approvals';
            }
          },
          {
            id: 'actions',
            render: rider => {
              return (
                <div>
                  <Button
                    color='RED'
                    inline={true}
                    onClick={handleDelete.bind(null, rider)}
                    small={true}
                    style={{}}
                  >
                    Delete
                  </Button>
                </div>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={riders}
        defaultSortColumn={{ id: 'rider_type' }}
        onRowClick={setRider}
      />
      {modal ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          onClose={() => {
            setModal(null);
          }}
          title={`Delete "${deleteInfo.name}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete {deleteInfo.name}?
          </div>
        </Modal>
      ) : null}
    </>
  );
};

List.propTypes = {
  version: PropTypes.object
};

export default List;
